<div class="d-flex w-100 m-2">
  <div class="card">
    <div class="card-body">
      <div *ngIf="!lightMode" class="card-title">
        <h5>{{ title }}</h5>
      </div>
      <div class="card-text d-flex flex-column">
        <div *ngFor="let data of docsData" class="d-flex flex-row align-items-center mt-1">
          <div class="icon">
            <a *ngIf="data.viewable; else iconContent" (click)="viewDoc(data)" (keyup)="viewDoc(data)"
              aria-disabled="true" appTooltip="Visualiser le document"><ng-container
                *ngTemplateOutlet="iconContent"></ng-container></a>
          </div>
          <ng-template #iconContent>
            <mat-icon appTooltip="Document certifié"
              *ngIf="data.doc.certified && !data.docIdentifierName && !data.doc.auto" color="accent"
              class="certified">verified_user</mat-icon>
            <mat-icon [appTooltip]="data.docIdentifierName" *ngIf="data.docIdentifierName" color="accent"
              class="certified">info</mat-icon>
            <mat-icon appTooltip="Document récupéré automatiquement" *ngIf="!data.docIdentifierName && data.doc.auto"
              color="accent" class="certified">cloud_done</mat-icon>
            <mat-icon class="file-type" color="primary"><i [class]="data.iconClass"></i></mat-icon>
          </ng-template>
          <div class="content">
            <a *ngIf="data.viewable; else docContent" (click)="viewDoc(data)" (keyup)="viewDoc(data)"
              aria-disabled="true" appTooltip="Visualiser le document">
              <ng-container *ngTemplateOutlet="docContent"></ng-container>
            </a>
          </div>
          <ng-template #docContent>
            <div class="name text-truncate">{{ data.doc.name }}</div>
            <div class="size text-truncate">{{ data.docDate }} {{ data.docDate ? '-' :''}} {{ data.doc.size | fileSize}}
            </div>
          </ng-template>
          <div class="actions">
            <ng-container *ngIf="lightMode; else actionMenu">
              <button mat-icon-button (click)="ligthModeOnDelete(data.doc)" appTooltip="Supprimer le document"><mat-icon
                  color="primary">delete_forever</mat-icon></button>
            </ng-container>
            <ng-template #actionMenu>
              <button mat-icon-button [matMenuTriggerFor]="actions" [matMenuTriggerData]="{data:data}">
                <mat-icon>more_vert</mat-icon>
              </button></ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<mat-menu #actions="matMenu">
  <ng-template matMenuContent let-row="data">
    <ul class="menu-actions">
      <li *ngIf="row.viewable">
        <a (click)="viewDoc(row)" (keyup)="viewDoc(row)" aria-disabled="true"><mat-icon
            color="primary">remove_red_eye</mat-icon><span class="text">Visualiser le
            document</span></a>
      </li>
      <li>
        <a [href]="row.url" [download]="row.filename"><mat-icon color="primary">cloud_download</mat-icon><span
            class="text">Télécharger le document</span></a>
      </li>
      <li *ngIf="row.canUpdate">
        <a (click)="edit(row.doc)" (keyup)="edit(row.doc)" aria-disabled="true"><mat-icon
            color="primary">create</mat-icon><span class="text">Modifier le
            document</span></a>
      </li>
      <li *ngIf="row.canDelete">
        <a (click)="confirmDelete(row.doc)" (keyup)="confirmDelete(row.doc)" aria-disabled="true">
          <mat-icon color="primary">delete_forever</mat-icon>
          <span class="text">Supprimer le document</span>
        </a>
      </li>
    </ul>
  </ng-template>
</mat-menu>
